import { EnvTeacherApi } from 'common/environments/teacher-api';
import { CoursewareServer } from 'common/environments/courseware-server';
import { ContentServer } from 'common/environments/content-server';
import { AigcServer } from 'common/environments/aigc';

export default {
  host: alo7Api.prefix.host,
  request: ['/api/v1', 'json'],
  items: [
    {
      items: {
        profile: ['get', '/auth'],
        knowledge_point_tree: ['get', '/knowledge_points_{subject}/knowledge_point_tree?includeLeaf={includeLeaf}'],
        course_catalogues_options: ['get', '/course_catalogue_{subject}/options?courseSeriesUuid={courseSeriesUuid}'],
        course_catalogues: ['get', '/course_catalogue_{subject}/listAll?courseUuid={courseUuid}'],
        course_catalogues_move: ['put', '/course_catalogue_{subject}/{uuid}/move'],
        course_catalogues_copy: ['post', '/course_catalogue_{subject}/{uuid}/copy_v2'],
        template_list: ['get', '/content_{subject}/options?businessConfigUuid={businessConfigUuid}'],
        templates_filters: ['get', '/templates/filters'],
        courseSeries_filters: ['get', '/course_series_{subject}/filters'],
        retry_ppt_convert: ['put', '/resources_{subject}/{uuid}/retry_ppt_convert'],
        business_config: ['get', '/business_config/{bizUuid}'],
        publish_progress: ['get', '/publish_event_{subject}/unfinished'],
        content_usages: ['get', '/content_{subject}/{uuid}/usages'],
        put_course_series: ['put', '/course_series_{subject}/{uuid}'],
        /* todo: 这里有冗余，后面会重构 */
        course_series: ['get', '/course_series_{subject}?pageNo={pageNo}&pageSize={pageSize}'],
        course: ['get', '/course_{subject}?pageSize={pageSize}&courseSeriesUuid={courseSeriesUuid}'],
        course_series_search: ['get', '/course_series_{subject}?{qs}'],
        course_search: ['get', '/course_{subject}?{qs}'],

        independent_business_contents: ['get', '/business_content_{subject}/{businessConfigUuid}/listBusinessContent{parmas}'],
        independent_business_existed_contents: ['post', '/business_content_{subject}/{businessConfigUuid}/existed_contents'],
        business_content_existed_contents: ['post', '/business_content_{subject}/existed_contents'],
        move_copy_business_node: ['post', '/business_nodes_{subject}/{uuid}/move_or_copy'],
        independent_catalogue_filter: ['get', '/business_catalogue_{subject}/{businessConfigUuid}/filters'],
        business_catalogue_search: ['get', '/business_catalogue_english/{type}?{qs}'],
        ppt_convert_progress_list: ['get', '/resources_{subject}/ppt_convert_progress_list{parmas}'],

        aot_operation_by_teacherid: ['get', '/aot/teacher/byUuid?uuid={uuid}'],
        generate_aot_upload_presigned: ['get', '/aot/generate_aot_upload_presigned?uploadType=AVATAR&fileName={fileName}'],
        business_classification_list: ['get', '/business_classification_{subject}/{businessConfigUuid}'],
        delete_course_series: ['delete', '/course_series_{subject}/{uuid}'],
        ellis_course_id_show: ['get', '/ellis/course/{id}'],
        custom_parameter_show: ['get', '/custom_parameter/{key}?type={type}'],
        custom_parameter_update: ['post', '/custom_parameter/{key}'],

        // 课程目录页资源操作: 上传/批量移动/批量删除
        catalog_resource_update: ['post', '/course_{subject}/{uuid}/edit_resource'],
        catalog_resource_batch_move: ['post', '/course_{subject}/{uuid}/edit_resources'],
        catalog_resource_batch_destroy: ['post', '/course_{subject}/{uuid}/remove_resources'],

        generate_upload_presigned: ['post', '/resources_{subject}/generate_upload_presigned'],
        complete_upload: ['put', '/resources_{subject}/complete_upload'],
        tasks_submit: ['post', '/tasks/submit'],
        tasks_submit_courseware_next: ['post', '/tasks/submit/courseware_next'],
        tasks_taskStatus: ['get', '/tasks/{taskId}'],
        tasks_history: ['get', '/tasks?businessUuid={businessUuid}'],
        tasks_get_by_business_content_uuid: [
          'get',
          '/tasks/getByBusinessContentUuid?businessContentUuid={businessContentUuid}&taskType={taskType}',
        ],
        batch_prepublish: ['put', '/business_content_english/{businessNodeUuid}/batch_prepublish'],
        batch_rename: ['put', '/business_content_{subject}/batch_update_title'],
        switch_display_level: ['put', '/business_content_{subject}/{uuid}/update_display_level?displayLevel={displayLevel}'],
      },
    },
    {
      host: ContentServer.get(process.env.NODE_ENV),
      request: ['/api/v5', 'json'],
      items: {
        courseware_units_filters: ['get', '/courseware_units/filters?coursewareId={coursewareId}'],
      },
    },
    {
      request: ['/api/v2', 'json'],
      items: {
        ai_courseware_setting: ['put', '/businesses_{subject}/{uuid}/ai_courseware_setting'],
        business_for_content_repository_list: ['get', '/businesses_{subject}/business_for_content_repository?courseUuid={courseUuid}'],
        courseware_move_or_copy: ['put', '/businesses_{subject}/{uuid}/move_or_copy'],
      },
    },
    {
      host: EnvTeacherApi.get(process.env.NODE_ENV),
      request: ['/api/v2', 'json'],
      items: {
        coursewares_by_school_get: ['get', '/teacher_resources/coursewares/findBySchool?schoolId={schoolId}'],
        coursewares_find_by_filter: ['get', '/teacher_resources/find_by_filter?{qs}'],
        coursewares_zip: ['get', '/teacher_resources/coursewares/{coursewareId}/zip'],
      },
    },
    {
      host: CoursewareServer.get(process.env.NODE_ENV),
      request: ['/api/v1', 'json'],
      items: {
        courseware_url_prepare_lessons: ['get', '/courseware_units/start_lessons_url?unitIds={unitIds}'],
      },
    },
    {
      host: 'https://abm-b2b-school.beta.saybot.net',
      request: ['/school/api/v1', 'json'],
      suffix: 'v10_',
      items: {
        organization_list_search: ['get', '/listByNameOrSn?name={name}'],
      },
    },
    {
      host: AigcServer.get(process.env.NODE_ENV),
      request: ['/admin/api', 'json'],
      items: {
        ai_talk_knowledge_show: ['get', '/ai_talk/knowledge/{studyPlanId}'],
        ai_talk_knowledge_update: ['post', '/ai_talk/knowledge/save/{studyPlanId}'],
        ai_talk_knowledge_publish: ['post', '/ai_talk/knowledge/publish/{studyPlanId}'],
      },
    },
  ],
};
